export default "__VITE_ASSET__Dpq7kmZ7__"